import { Routes } from '@angular/router';
import { PageNotFoundComponent } from './ui/components/page-not-found/page-not-found.component';
import { BlankPageComponent } from './ui/components/blank-page/blank-page.component';
import { mustBeSignedInGuard, mustNotBeSignedInGuard, rootGuard } from './routing';
import { TICKET_SELLING_BASE_URL } from './modules/admin-ticket-selling/navigation/ticket-selling-navigation.models';

export const routes: Routes = [
  {
    path: 'seating-preview/:organizationId',
    loadComponent: () => import('./modules/seating-preview/seating-preview-page.component').then(m => m.SeatingPreviewPageComponent)
  },
  {
    path: 'login',
    canActivate: [ mustNotBeSignedInGuard ],
    loadChildren: () => import('./modules/auth/auth.routes').then(m => m.ROUTES)
  },
  {
    path: 'welcome',
    canActivate: [ mustBeSignedInGuard ],
    loadComponent: () => import('./modules/welcome/welcome-page.component').then(m => m.WelcomePageComponent)
  },
  {
    path: 'profile',
    canActivate: [ mustBeSignedInGuard ],
    loadChildren: () => import('./modules/profile/profile.routes').then(m => m.ROUTES)
  },
  {
    path: `${TICKET_SELLING_BASE_URL}/:membershipId`,
    canActivate: [ mustBeSignedInGuard ],
    loadChildren: () => import('./modules/admin-ticket-selling/ticket-selling.routes').then(m => m.ROUTES)
  },
  {
    path: '',
    pathMatch: 'full',
    canActivate: [ rootGuard ],
    component: BlankPageComponent,
  },
  {
    path: '**',
    component: PageNotFoundComponent,
  }
];
